import { render, staticRenderFns } from "./TextInputWithEditorButton.vue?vue&type=template&id=672878ee"
import script from "./TextInputWithEditorButton.vue?vue&type=script&lang=js"
export * from "./TextInputWithEditorButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports